import React from "react";
import { useGlobal } from "reactn";
import * as Styled from "./style";
import { Link } from "gatsby";
import Chip from "@material-ui/core/Chip";


const Taggar = ({ mainPage, subPage, data }) => {
  let [english] = useGlobal("English");
  const Synligataggar = data
  mainPage = mainPage.toLowerCase().trim()
  subPage = subPage.toLowerCase().trim()
  let arr = []

  switch(mainPage){
    case "restaurant":
      arr = [ 
        { "name":"Lunch","namn":"Lunch","url":"/lunch"},
        { "name":"Brunch","namn":"Brunch","url":"/brunch"},
        { "name":"Chambre","namn":"Chambre","url":"/chambre"},
        { "name":"Dinner", "namn":"Middag","url":"/dinner"},
        { "name":"Cocktail","namn":"Drinkar","url":"/cocktail"},
        { "name":"Rooftop bar","namn":"Takbar","url":"/roofbar"},
        { "name":"Outdoor seeting","namn":"Uteserveringar","url":"/uteservering"},
        { "name":"Christmas","namn":"Julbord","url":"/christmas"}
      ]
      break;

      case "nightlife":
        arr = [
          { "name":"All","namn":"Alla","url":' '},
          { "name":"New Year","namn":"Nyår","url":"/newyear"},
          { "name":"Reservedtable","namn":"Drinkbord","url":"/reservedtable"},
        ]
        break;

      case "bar":
        arr = [
          { "name":"All","namn":"Alla","url":' '},
          { "name":"Outdoor Seating","namn":"Uteservering","url":"/outdoor"},
        ]
        break;


        case "lokal":
          arr = [
            { "name":"All","namn":"Alla","url":' '},
            { "name":"Party","namn":"Fest","url":"/party"},
            { "name":"Dinner","namn":"Middag","url":"/dinner"},
            { "name":"Conference","namn":"Konferens","url":"/conference"},
          ]
          break;
      
      
      default:
        arr = []
  }
  const mappingTags = arr.filter(i => Synligataggar.includes(i.namn)).map((tag, index) => {
   return (
     <Link key={index} className="textDecorationNone" to={`/${mainPage}${tag.url}#search`}>
      <Styled.Tag active={tag.namn.toLowerCase() === subPage}>
        <Chip label={english ? tag.name :tag.namn} />
      </Styled.Tag>
     </Link>
   )       
})
  return(
  <>
    {Synligataggar.includes("Dölj alla") ? null : (
      <Styled.Tags>
        <Link className="textDecorationNone" to={`/${mainPage}/#search`}>
          <Styled.Tag active={subPage === 'alla'}>
            <Chip label={english ? "All" : "Alla"} />
          </Styled.Tag>
        </Link>
        {mappingTags}
        </Styled.Tags>
    )}
  </>
  )
};

export default Taggar
